import React from "react";
import FeatureCategory from "../../featurecategory";
import SEO from "../../seo";

export default function MemoryFoamPage() {
  const categoryName = "Latex";

  const products = [
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Coil-on-Coil-1.png",
      name: "COIL ON COIL",
      link: "/patent-series-mattress/coil-on-coil/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Tiara-Cool-1.png",
      name: "TIARA COOL",
      link: "/patent-series-mattress/tiara-cool/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Accolade.png",
      name: "ACCOLADE PT",
      link: "/patent-series-mattress/accolade-pt/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Romance-1.png",
      name: "ROMANCE",
      link: "/patent-series-mattress/romance/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-cover.png",
      name: "HARMONY ORTHO",
      link: "/harmony-collection/harmony-ortho/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667.png",
      name: "NATURA LATEX",
      link: "/latex-mattress/natura-latex/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/portofino-Latex.png",
      name: "PORTOFINO LATEX",
      link: "/latex-mattress/portofino-latex/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-cover-1.png",
      name: "ORTHO LATEX LX",
      link: "/luxury-collection/ortho-latex-lx/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Princeton-Latex.png",
      name: "PRINCETON LATEX",
      link: "/latex-mattress/princeton-latex/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Ortho-Latex.png",
      name: "ORTHO LATEX",
      link: "/latex-mattress/ortho-latex/",
    },
  ];

  const categoryDescription =
    "Latex conforms to any sleeping position and relaxes the body’s pressure points, guaranteeing comfortable, restful sleep. Highly breathable and virtually dust mite resistant, latex mattresses also provide relief from respiratory issues. <br/><br/>Eclipse guarantees the use of the best-quality natural latex coming from selected and controlled plantations and tested before transformation in the proprietary production process.";

  return (
    <div>
      <SEO
        title="Latex Mattress | Eclipse International"
        description="Mattresses that utilise the best-quality natural latex for pressure-relief, high breathability and anti-microbial properties. Best mattresses for asthma sufferers."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
      />
      <FeatureCategory
        products={products}
        categoryName={categoryName}
        categoryDescription={categoryDescription}
      />
    </div>
  );
}
